import React from "react";
import App from "./App";
import ReactDOM from "react-dom/client";

import "./styles/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App></App>
);